export default __webpack_public_path__ + "static/media/Microsoft.7d5a14ce.svg";